import FooterOne from "./FooterOne";
import FooterTwo from "./FooterTwo";
import FooterThree from "./FooterThree";
import FooterComponent from "./FooterComponent";

export default FooterComponent

export {
  FooterOne,
  FooterTwo,
  FooterThree
}